var map = {
	"./1.png": "acae",
	"./2.png": "2b8b",
	"./3.png": "1b74",
	"./4.png": "b212",
	"./5.png": "42a0",
	"./6.png": "887b",
	"./7.png": "96e2",
	"./8.png": "bc7f",
	"./eng/1.png": "55e2",
	"./eng/2.png": "7264",
	"./eng/3.png": "5645",
	"./eng/4.png": "886f",
	"./eng/5.png": "4d6b",
	"./eng/6.png": "7b6b",
	"./eng/7.png": "7cd8",
	"./eng/8.png": "b472"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "82e6";